export const PERSON_CREATE_REQUESTED = 'PERSON_CREATE_REQUESTED';
export const PERSON_CREATE_SUCCEEDED = 'PERSON_CREATE_SUCCEEDED';
export const PERSON_CREATE_FAILED = 'PERSON_CREATE_FAILED';

export const PERSON_UPDATE_REQUESTED = 'PERSON_UPDATE_REQUESTED';
export const PERSON_UPDATE_SUCCEEDED = 'PERSON_UPDATE_SUCCEEDED';
export const PERSON_UPDATE_FAILED = 'PERSON_UPDATE_FAILED';

export const PERSON_DELETE_REQUESTED = 'PERSON_DELETE_REQUESTED';
export const PERSON_DELETE_SUCCEEDED = 'PERSON_DELETE_SUCCEEDED';
export const PERSON_DELETE_FAILED = 'PERSON_DELETE_FAILED';

export const PERSON_GROUPED_PEOPLE_EXPORT_REQUESTED =
    'PERSON_GROUPED_PEOPLE_EXPORT_REQUESTED';
export const PERSON_GROUPED_PEOPLE_EXPORT_SUCCEEDED =
    'PERSON_GROUPED_PEOPLE_EXPORT_SUCCEEDED';
export const PERSON_GROUPED_PEOPLE_EXPORT_FAILED =
    'PERSON_GROUPED_PEOPLE_EXPORT_FAILED';
export const PERSON_GROUPED_PEOPLE_EXPORT_NAMESPACE =
    'PERSON_GROUPED_PEOPLE_EXPORT';

export const PERSON_GROUPED_PEOPLE_IMPORT_REQUESTED =
    'PERSON_GROUPED_PEOPLE_IMPORT_REQUESTED';
export const PERSON_GROUPED_PEOPLE_IMPORT_SUCCEEDED =
    'PERSON_GROUPED_PEOPLE_IMPORT_SUCCEEDED';
export const PERSON_GROUPED_PEOPLE_IMPORT_FAILED =
    'PERSON_GROUPED_PEOPLE_IMPORT_FAILED';
export const PERSON_GROUPED_PEOPLE_IMPORT_NAMESPACE =
    'PERSON_GROUPED_PEOPLE_IMPORT';
